import { selectorFamily } from 'recoil';
import { tabState } from '../../common';
import { Tab } from '../../../../../types/estimate/common/Tab';
import { EstimateList } from '../../../../../types/estimate/common/EstimateInfo';
import { otherBankMakerFinanceListState } from './atom';
import { OtherBank } from '../../../../../types/estimate/common/OtherBank';
/**
 *  하나의 탭에 조회하려는 지불방법 목록
 * @param {number} id 조회할 탭 번호
 * @param {string} name 조회할 목록 이름
 * @return 탭당 name으로 선택한 지불방법 테이블 목록
 *  */
export const otherBankListState = selectorFamily<any, { id?: number; name: string }>({
  key: 'otherBankList',
  get:
    (params: { id?: number; name: string }) =>
    ({ get }) => {
      const { id, name } = params;
      const tabId: number = id || get(tabState).find((tab: Tab) => tab.active)?.id || 1;

      switch (name) {
        case 'otherBankMakerFinance':
          // 타금융사 할부 메이커금융 상품 목록
          return get(otherBankMakerFinanceListState).find(
            (item: EstimateList<OtherBank>) => item.id === tabId
          )?.list;

        default:
          return undefined;
      }
    },
});
